import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1ded06d6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "rowText"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "textGray"
  }, "免费版", -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "textOrange"
  }, "升级/续费", -1);
});

var _hoisted_4 = {
  class: "rowText"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "textGray"
  }, "套餐剩余", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "textGray"
  }, "0页（高清），214页标清", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "textOrange"
  }, "购买套餐 >", -1);
});

var _hoisted_8 = {
  class: "rowText"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "textGray"
  }, "谱币：0", -1);
});

export default {
  setup: function setup(__props) {
    var account = localStorage.getItem('account');
    var url = 'https://img0.baidu.com/it/u=2601170227,3207786263&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500';
    return function (_ctx, _cache) {
      var _component_el_image = _resolveComponent("el-image");

      var _component_el_col = _resolveComponent("el-col");

      var _component_sunny = _resolveComponent("sunny");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_wallet = _resolveComponent("wallet");

      var _component_orange = _resolveComponent("orange");

      var _component_el_row = _resolveComponent("el-row");

      var _component_el_card = _resolveComponent("el-card");

      return _openBlock(), _createBlock(_component_el_card, {
        class: "box-card"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 3,
                class: "imageContainer"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_image, {
                    class: "image",
                    src: url
                  })];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 21
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("h3", null, _toDisplayString(_unref(account)), 1), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_icon, {
                    class: "icon"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_sunny)];
                    }),
                    _: 1
                  }), _hoisted_2, _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
                    class: "icon"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_wallet)];
                    }),
                    _: 1
                  }), _hoisted_5, _hoisted_6, _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, {
                    class: "icon"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_orange)];
                    }),
                    _: 1
                  }), _hoisted_9])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      });
    };
  }
};